let careerData = [];

careerData = [
        {
            title: "I'm a...",
            description: "Watch some videos of real people working in computer science describe their work with Code.org!",
            link: "https://code.org/careers-with-cs#videos"
        },
        {
            title: "Work in Tech",
            description: "Learn about jobs in tech, including design, research, engineering, and more, with Khan Academy.",
            link: "https://www.khanacademy.org/college-careers-more/career-content/work-in-tech"
        }
    ]


export default careerData;
